import React, { useState } from 'react';
import Sidebar from '../components/Sidebar';
import { Nav, NavItem, NavLink } from 'reactstrap';
import AmbassadorOverview from '../components/AmbassadorOverview';
import MyReferrals from '../components/MyReferrals';

const Dashboard = ({ onLogout }) => {
    const [activeTab, setActiveTab] = useState('overview');

    return (
        <div className='d-flex w-100 overflow-hidden'>
            <div className='asidebar'>
                <Sidebar onLogout={onLogout} />
            </div>
            <div className='main-content'>
                <div className='d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-between mb-4 gap-3'>
                    <div>
                        <h1 className="mb-2 fw-bold" style={{ fontSize: '1.875rem', color: '#1e293b' }}>Ambassador Dashboard</h1>
                        <p className="text-muted mb-0 small">View your performance and referral statistics</p>
                    </div>
                </div>

                {/* Tabs */}
                <Nav tabs className="mb-4">
                    <NavItem>
                        <NavLink
                            className={activeTab === 'overview' ? 'active' : ''}
                            onClick={() => setActiveTab('overview')}
                            style={{ cursor: 'pointer' }}
                        >
                            Overview
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={activeTab === 'referrals' ? 'active' : ''}
                            onClick={() => setActiveTab('referrals')}
                            style={{ cursor: 'pointer' }}
                        >
                            My Referrals
                        </NavLink>
                    </NavItem>
                </Nav>

                {/* Tab Content */}
                {activeTab === 'overview' && <AmbassadorOverview />}
                {activeTab === 'referrals' && <MyReferrals />}
            </div>
        </div>
    );
}

export default Dashboard;
